import ExcelIcon from '../../assets/img/Excel'
import { IconButton, Tooltip } from '@mui/material';

import * as FSaver from 'file-saver';
import * as XLSX from 'xlsx';

const ArrayExcelSaver = (props)=>{

    const {
        data=[],
        name=`Report_${(new Date()).toDateString()}`,
        description='Отчет'
    } = props

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileName=`${name}.xlsx`;

    /*
            if(geoMultiObjReportExcel && geoMultiObjReportExcel.data && !geoMultiObjReportExcel.loading){


        }
    */
    const handleClick = ()=>{
        if(data.length){
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet(data);
            XLSX.utils.book_append_sheet(workbook, worksheet, description.substring(0,31), true);
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const sData = new Blob([excelBuffer], {type: fileType});
            FSaver.saveAs(sData, fileName);
        }
    }
    return <Tooltip title={`Скачать ${fileName}`}><IconButton disabled={!data.length} color="mainButton" onClick={handleClick} ><ExcelIcon /></IconButton></Tooltip>

}

export default ArrayExcelSaver